<template>
  <div class="hero-section">
    <div class="hero-content">
      <div class="hero-text">
        <div class="vertical-bar"></div>
        <h1>
          <span class="highlight-blue">Get Your Dream</span>
          <br />
          <span class="highlight-yellow">Invested.</span>
        </h1>
        <p class="subtitle">
          <!-- eslint-disable-next-line prettier/prettier -->
          Empowering individuals to achieve their financial dreams through personalized, unbiased investment solutions.
        </p>
        <div class="hero-actions">
          <router-link to="/contact" class="get-invested-btn">
            Get Invested
          </router-link>
          <div class="workshop-card">
            <div class="workshop-header">
              <i class="fas fa-graduation-cap"></i>
              <h3 class="workshop-title">
                Children's Day "Money Management" Workshop for Kids
              </h3>
            </div>
            <div class="workshop-details">
              <div class="workshop-detail-item">
                <i class="fas fa-calendar-alt"></i>
                <span>22-Nov-2025</span>
              </div>
              <div class="workshop-detail-item">
                <i class="fas fa-clock"></i>
                <span>06:00 PM - 07:30 PM</span>
              </div>
            </div>
            <!-- <router-link to="/register" class="register-student-btn"> -->
            <i class="fas fa-user-plus"></i>
            Registration Closed
            <!-- </router-link> -->
          </div>
        </div>
      </div>
      <div class="hero-image">
        <div class="hero-illustration">
          <!-- eslint-disable-next-line prettier/prettier -->
          <img src="@/assets/blogs/level_up.jpg" alt="Investment Level Up" class="level-up-image" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeroTab",
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap");

.hero-section {
  background-color: #f6f2f1;
  padding: 4rem 2rem;
  min-height: 80vh;
  display: flex;
  align-items: center;
  font-family: "Roboto", sans-serif;
}

.hero-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: left;
  gap: 4rem;
}

.hero-text {
  text-align: left;
  flex: 1;
  position: relative;
  padding-left: 2rem;
}

.vertical-bar {
  position: absolute;
  left: 0;
  top: 80;
  width: 12px;
  height: 60%;
  background-color: #072ac8;
  border-radius: 3px;
}

h1 {
  font-size: 4rem;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
}

.highlight-blue {
  color: #072ac8;
}

.highlight-yellow {
  color: #ffd700;
}

.subtitle {
  color: #4a5568;
  font-size: 1.2rem;
  margin-bottom: 2rem;
  line-height: 1.6;
  max-width: 600px;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
}

.hero-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.get-invested-btn {
  display: inline-block;
  background-color: #072ac8;
  color: white;
  padding: 1rem 2rem;
  border-radius: 30px;
  text-decoration: none;
  font-weight: bold;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(7, 42, 200, 0.3);
}

.get-invested-btn:hover {
  transform: translateY(-2px);
  background-color: #0522a5;
  box-shadow: 0 6px 16px rgba(7, 42, 200, 0.4);
}

.workshop-card {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(255, 250, 240, 0.95) 100%
  );
  border-radius: 20px;
  padding: 1.5rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 215, 0, 0.3);
  max-width: 500px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.workshop-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 215, 0, 0.5);
}

.workshop-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid rgba(255, 215, 0, 0.2);
}

.workshop-header i {
  font-size: 1.5rem;
  color: #ffd700;
  animation: bounce 2s infinite;
}

.workshop-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #072ac8;
  margin: 0;
  font-family: "Roboto", sans-serif;
  line-height: 1.4;
}

.workshop-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}

.workshop-detail-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #4a5568;
  font-size: 0.95rem;
  font-weight: 500;
}

.workshop-detail-item i {
  color: #ffd700;
  font-size: 1rem;
  width: 20px;
  text-align: center;
}

.register-student-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%);
  color: #072ac8;
  padding: 0.875rem 2rem;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 700;
  font-size: 1rem;
  transition: all 0.3s ease;
  font-family: "Roboto", sans-serif;
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
  border: 2px solid transparent;
  width: 100%;
  box-sizing: border-box;
  max-width: 100%;
}

.register-student-btn:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 6px 20px rgba(255, 215, 0, 0.5);
  background: linear-gradient(135deg, #ffed4e 0%, #ffd700 100%);
  border-color: #072ac8;
}

.register-student-btn i {
  font-size: 1rem;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

.registration-note {
  margin-top: 1rem;
  color: #4a5568;
  font-size: 0.875rem;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background-color: rgba(255, 215, 0, 0.1);
  border-radius: 8px;
  text-align: center;
  margin-left: 0;
  margin-right: 0;
  animation: blink 2s infinite;
}

.registration-note i {
  color: #ffd700;
  font-size: 1rem;
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

.hero-image {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-illustration {
  width: 100%;
  max-width: 500px;
  display: flex;
  justify-content: center;
}

.level-up-image {
  width: 100%;
  height: auto;
  max-width: 500px;
  border-radius: 8px;
}

@media (max-width: 1024px) {
  .hero-content {
    flex-direction: column;
    text-align: center;
    gap: 2rem;
  }

  .hero-text {
    padding-left: 0;
  }

  .vertical-bar {
    display: none;
  }

  h1 {
    font-size: 3rem;
  }

  .subtitle {
    margin: 1.5rem auto;
  }

  .hero-actions {
    justify-content: center;
  }

  .hero-illustration {
    margin-top: 2rem;
  }
}

@media (max-width: 768px) {
  .hero-section {
    padding: 2rem 1rem;
  }

  h1 {
    font-size: 2.5rem;
  }

  .level-up-image {
    max-width: 100%;
  }

  .hero-actions {
    flex-direction: column;
    width: 100%;
  }

  .get-invested-btn {
    width: 100%;
    justify-content: center;
    text-align: center;
  }

  .workshop-card {
    max-width: 100%;
    padding: 1.25rem;
  }

  .workshop-title {
    font-size: 1rem;
  }

  .workshop-details {
    gap: 0.5rem;
    margin-bottom: 1rem;
  }

  .registration-note {
    width: 100%;
    justify-content: center;
    text-align: center;
    margin-top: 0.75rem;
  }
}
</style>
